export const EMPTY_ARRAY = Object.freeze([]) as any[];
